const { cashbackPaquetes } = require("../constants/packageAwards");

module.exports = {
  ofertaNomina: {
    titulo: "Cobrá tu sueldo en BBVA",
    canonical: "https://www.bbva.com.ar/abrir-cuenta-sueldo/",
    description: `Comenzá a cobrar tu sueldo en BBVA y accedé a beneficios exclusivos. Abrí tu Cuenta Sueldo y recibí hasta ${cashbackPaquetes.LIBRETON_PREMIUM_WORLD} de bienvenida.`,
    adobeTargetActive: true,
    googleGTMId: "GTM-PH65K3Q"
  },
  ofertaCajaAhorro: {
    titulo: "Solicitá tu Caja de ahorro Online",
    canonical: "https://www.bbva.com.ar/solicitar-caja-de-ahorro/",
    description:
      "Solicitá la apertura de tu caja de ahorro de manera online sin ningún tipo de costo junto a BBVA ¡Abrila haciendo click acá!",
    adobeTargetActive: true,
    googleGTMId: "GTM-TWRMS62"
  },
  ofertaCGU: {
    titulo: "Abrí tu Cuenta Gratuita Universal Online",
    canonical: "https://www.bbva.com.ar/abrir-cuenta-gratuita-universal/",
    description:
      "Realizá la apertura de tu cuenta gratuita universal de manera 100% online junto a BBVA ¡Abrila haciendo click acá!",
    adobeTargetActive: false,
    googleGTMId: null
  },
  ofertaEmprendedores: {
    titulo: "Cobrá con Openpay de forma rápida y segura",
    canonical: "https://www.bbva.com.ar/solicitar-openpay/",
    description:
      "Conocé la app de cobro de BBVA diseñada para todo tipo de negocios. Vas a poder cobrar con código QR, link de pago y lector de tarjetas. ¡Conocé más!",
    adobeTargetActive: true,
    googleGTMId: null
  }
};
